export const HEADER_BREAK_POINT = 1024 // must be same as $header-break-point scss variable in _variables.scss
